import React from 'react';

import LabelIcon from '../../components/label-icon';
import MarkerIcon from '../../assets/marker-icon';
import UsersIcon from '../../assets/users-icon';
import ParkingSignIcon from '../../assets/parking-sign-icon';
import AngleRightIcon from '../../assets/angle-right-icon';
import Slider from '../../components/slider';
import { API } from '../../helpers/constants';
import { useParams } from 'react-router-dom';
import Error from '../../components/error';
import { convertToArray } from '../../helpers/array';
import LoadingDetails from './components/loading-details';
import useGet from '../../hook/use-get';
import BackButton from "../../components/back-button";

const TourDetails = () => {
  const { tourId } = useParams();
  const { data, isError, isFetching, refetch } = useGet({
    queryKey: 'tourDetails',
    api: `${API.tourDetails}?id=${tourId}`
  });
  const getParkingLabel = () => {
    const label = [];

    if (data?.['parking_car']) {
      label.push(`${data['parking_car']} Kendaraan Roda Empat`);
    }
    if (data?.['parking_motor']) {
      label.push(`${data['parking_motor']} Kendaraan Roda Dua`);
    }

    return label;
  };

  const RenderContent = () => {
    if (isFetching) {
      return <LoadingDetails />;
    }

    if (isError) {
      return <Error refetch={refetch} />;
    }

    return (
      <>
        <BackButton />
        <div className="mb-10 mt-4">
          <Slider
              contents={convertToArray(data?.['file_url'])}
              isRounded
              imgClassnames="max-h-[185px] lg:max-h-[445px] object-cover"
          />
        </div>
        <h1 className="text-left text-2xl lg:text-4xl mb-7 font-bold">{data?.name}</h1>
        <div className="my-3">
          <LabelIcon
            label={`${data?.['city_name']}, ${data?.['province_name']}`}
            icon={<MarkerIcon size={24} />}
          />
        </div>
        <div className="my-3">
          <LabelIcon label={`${data?.kapasitas} Orang/hari`} icon={<UsersIcon size={24} />} />
        </div>
        <div className="my-3">
          <LabelIcon label={getParkingLabel().join(', ')} icon={<ParkingSignIcon />} />
        </div>
        <hr className="my-10" />
        <h2 className="text-left text-2xl font-bold my-8">Informasi</h2>
        <p className="text-left text-base">{data?.description}</p>
        <h2 className="text-left text-2xl font-bold my-8">Fasilitas</h2>
        <div className="flex md:grid flex-col flex-wrap md:grid-cols-2 gap-3">
          {data?.facility?.map((item) => (
            <LabelIcon label={item?.name} icon={item?.icon} />
          ))}
        </div>
        <h2 className="text-left text-2xl font-bold mt-8 mb-2">Lokasi</h2>
        <div className="flex items-start gap-4">
          <MarkerIcon size={24} />
          <div className="text-left lg:flex md:gap-3">
            {data?.address}
            <div className="flex self-start mt-2 md:mt-0">
              <a
                href={data?.['location_gmap']}
                className="text-[#0AB7F1] text-base inline-flex items-center gap-2"
                target="_blank"
              >
                Buka di Maps
                <AngleRightIcon color="#0AB7F1" />
              </a>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="flex justify-center py-14">
      <div className="w-[80%] md:w-[65%]">
        <RenderContent />
      </div>
    </div>
  );
};

export default TourDetails;
